// import axios from "axios";
// import authHeader from './auth-header';
// import { API_URL } from '../common/globalvars'

// // const authheader = authHeader();
// console.log('akkkkk',authHeader());

// export default axios.create({
//   baseURL: API_URL,
//   headers: authHeader()
// });



import axios from "axios";
import authHeader from './auth-header';
import { API_URL } from '../common/globalvars'

const http = axios.create({
  baseURL: API_URL,
});

// Add a request interceptor
http.interceptors.request.use(
  (config) => {
    // Call authHeader() for each request
    config.headers = {
      ...config.headers,
      ...authHeader(),
    };    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default http;


